const SameDigitsCPF = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"];
const SameDigitsCNPJ = ["00000000000000", "11111111111111", "22222222222222", "33333333333333", "44444444444444", "55555555555555", "66666666666666", "77777777777777", "88888888888888", "99999999999999"];

export function emailValid(email) {
  var emailPattern =  /^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/;
  return emailPattern.test(email);
}

export function isValidCPF(cpf) {
  let numeros, digitos, soma, i, resultado;
  let digitosIguais = 1;

  cpf = cpf.toString().replace(/\D/gi, '');

  if (cpf.length < 11) return false;

  // Elimina CPF invalidos conhecidos
  if (SameDigitsCPF.indexOf(cpf) >= 0) return false;

  for (i = 0; i < cpf.length - 1; i++) {
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      digitosIguais = 0;
      break;
    }
  }

  if (!digitosIguais) {
    numeros = cpf.substring(0, 9);
    digitos = cpf.substring(9);
    soma = 0;

    for (i = 10; i > 1; i--) {
      soma += numeros.charAt(10 - i) * i;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado.toString() !== digitos.charAt(0)) { return false; }

    numeros = cpf.substring(0, 10);
    soma = 0;

    for (i = 11; i > 1; i--) {
      soma += numeros.charAt(11 - i) * i;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado.toString() !== digitos.charAt(1)) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function isValidCNPJ(cnpj) {
  cnpj = cnpj.toString().replace(/\D/gi, '');

  if (cnpj == '') return;

  if (cnpj.length < 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (SameDigitsCNPJ.indexOf(cnpj) >= 0) return false;

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

  if (resultado != digitos.charAt(1)) return false;

  return true;
}

export function isValidCNS(cns) {
  if(cns.toString().replace(/\D/g, '').length < 15) {
    return false;
  }

  return true;
}

export function isValidCNES(cnes) {
  if(cnes.toString().replace(/\D/g, '').length < 7) {
    return false;
  }

  return true;
}




// WEBPACK FOOTER //
// ./src/app/util/validation.ts